import {CollectionViewer} from '@angular/cdk/collections';
import {Observable} from 'rxjs';
import {LogService} from '@aam/angular-logging';
import {POObjectNotify, POPage, POParkingSpace} from '@objects-module/model';
import {POParkingSpaceReportTypes} from '../model/POParkingSpace';
import {
  ParkingLocationStatistics,
  POLocationService,
} from '@store/services/POLocation.service';
import {CustomDatasource} from '@objects-module/datasource/base/CustomDatasource';
import {ParkingSpaceReportsFilter} from '@list-decorators/filters/ParkingSpaceReportsFilter';
import {POObjectStatusNotify} from '@obj-models/notify/POObjectStatusNotify';

export class POParkingSpaceGuardDatasource extends CustomDatasource<ParkingLocationStatistics> {
  filters: ParkingSpaceReportsFilter[] = [];
  objectType = POParkingSpace.type;

  constructor(public service: POLocationService, protected log: LogService) {
    super();
  }

  public loadPage(
    filterExpression: ParkingSpaceReportsFilter,
    sortExpression: string,
    pageIndex: number,
    pageSize: number
  ) {
    this.loading$$.next(true);
    this.service
      .getPagedCarsOnParkingSpacesInfo(pageIndex, pageSize, filterExpression)
      .subscribe((r: POPage<ParkingLocationStatistics>) => {
        this.data$$.next(r.content);
        this.elementsOnPage$$.next(r.numberOfElements);
        this.totalElements$$.next(r.totalElements);
        this.loading$$.next(false);
      });
  }

  public deletePack(data: ParkingLocationStatistics[]) {}

  public deleteFromList(item: ParkingLocationStatistics) {}

  shouldReloadPage(notify: POObjectNotify): boolean {
    return (
      notify.notifyType === POObjectStatusNotify.cacheUpdated &&
      notify.objectType === this.objectType
    );
  }

  connect(
    collectionViewer: CollectionViewer
  ): Observable<ParkingLocationStatistics[]> {
    return this.data$;
  }

  disconnect(collectionViewer: CollectionViewer): void {}
}
